<template>
  <div class="contents" data-editor-active>
    <h3 class="title" ref="title" data-grid-layout="title">
      공정도
    </h3>
    <div data-grid-layout="tl"> </div>
    <div class="" data-grid-layout="tr">
    </div>
    <div class="" ref="process" data-grid-layout="content">
      <p    v-show="!item?.thumbnail" class="emptyProcess">공정도 이미지가 없습니다.</p>
      <img  v-show="item?.thumbnail" :src="item?.thumbnail != null ? `data:image/jpeg;base64,${item?.thumbnail}` : '' " class="processImage"/>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    item: { type: Object, default: {} },
  },
}
</script>
<style lang="scss" scoped>
.emptyProcess {
  display: flex; 
  align-items: center; 
  justify-content: center; 
  text-align: center;
  font-size: 15px;
  @include text-prt-b;
  height: 46px; 
  color: $gray-9; 
  border: 1px solid $gray-d; 
  background-color: $gray-f5; 
}
.processImage {
  min-width: 250px; width: auto; max-width: 500px;
  min-height: 30px;
}
</style>